import SettingsItemText from "@/components/PageEditor/components/Viewport/components/Sidebar/components/Settings/components/SettingsItemText";
import SettingsSection from "@/components/PageEditor/components/Viewport/components/Sidebar/components/Settings/components/SettingsSection";
import { useEditor, useNode } from "@craftjs/core";
import { Button, Grid } from "@mui/material";

const Settings = () => {
    const {
        id,
        actions: { setProp },
    } = useNode();

    const { mediaSource, actions } = useEditor((state) => ({
        mediaSource: state.nodes[id] && state.nodes[id].data.props.src,
    }));

    return (
        <SettingsSection title="Video">
            <Grid size={{ xs: 12 }}>
                <SettingsItemText
                    type={"text"}
                    value={mediaSource}
                    onChange={(value: string) => {
                        actions.setProp(id, (props) => (props.src = value));
                    }}
                    fullWidth={true}
                    label="External URL"
                />
            </Grid>

            <Grid size={{ xs: 12 }}>
                {Boolean(mediaSource) && (
                    <Button
                        variant="contained"
                        fullWidth
                        color="error"
                        size="small"
                        onClick={() => {
                            // eslint-disable-next-line @typescript-eslint/no-explicit-any
                            setProp((prop: any) => {
                                prop.src = "";
                                prop.type = "";
                            });
                        }}
                    >
                        Clear file
                    </Button>
                )}
            </Grid>
        </SettingsSection>
    );
};

export default Settings;
